import { all, fork } from "redux-saga/effects";
import modalSaga from "store/sagas/modal/modal.saga";
import datesSaga from "store/sagas/dates/dates.saga";
import { applicationMux } from "./application";
import { surveySaga } from "../../modules/survey/infrastructure/store/saga/survey.saga";
import { spaceSaga } from "../../modules/spaces/infrastructure/store/saga/space.saga";
import authSaga from "./auth/auth.saga";
import { roomsSaga } from "./rooms/rooms.saga";
import filtersSaga from "./filters/filters.saga";
import environmentSaga from "./environment/environment.saga";

export default function* rootSaga() {
  yield all([
    fork(applicationMux),
    fork(surveySaga),
    fork(datesSaga),
    fork(spaceSaga),
    fork(modalSaga),
    fork(authSaga),
    fork(roomsSaga),
    fork(filtersSaga),
    fork(environmentSaga),
  ]);
}
